import { LOAD_CHANNELS_LIVE } from '@/store/protocols'

export default [
    {
        path: '/lives/:id/index.html',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_LIVE.join('/')
        }
    }
]